import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AssortmentHierarcyContextProvider } from "./components/context/AssortmentHierarcyContext";
import { CategoryHierarcyContextProvider } from "./components/context/CategoryHierarcyContext";
import { SubcatHierarcyContextProvider } from "./components/context/SubcatHierarcyContext";
import { FixtureContextProvider } from "./components/context/FixtureContext";
import { SubcatRestrictContextProvider } from "./components/context/SubcatRestrictContext";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SubcatRestrictContextProvider>
    <FixtureContextProvider>
      <SubcatHierarcyContextProvider>
        <CategoryHierarcyContextProvider>
          <AssortmentHierarcyContextProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AssortmentHierarcyContextProvider>
        </CategoryHierarcyContextProvider>
      </SubcatHierarcyContextProvider>
    </FixtureContextProvider>
  </SubcatRestrictContextProvider>
);
